import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getNodeByKey, $isTextNode, $createRangeSelection, $setSelection } from 'lexical';
import { useSelectionStore } from '../../../../EdgeDocs/EdgeDocsCore/stores/useSelectionStore';

export const SelectionApplyPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unsub = useSelectionStore.subscribe((state: any) => {
      const pending = state?.pendingCaret;
      if (!pending) return;
      const commit = useSelectionStore.getState().commitPendingCaret;
      const caret = commit();
      if (!caret) return;
      editor.update(() => {
        // Accept either exact runId or base textNodeKey (server can provide base key)
        let nodeKey = caret.runId;
        const maybeBase = (caret as any).textNodeKey as string | undefined;
        if (maybeBase) nodeKey = maybeBase;
        const textNode = $getNodeByKey(nodeKey);
        if (textNode && $isTextNode(textNode)) {
          const sel = $createRangeSelection();
          sel.setTextNodeRange(textNode, caret.offset, textNode, caret.offset);
          $setSelection(sel);
          // Ensure caret becomes visible immediately
          try { (editor as any).focus?.(); } catch {}
        }
      });
    });
    return () => { try { unsub(); } catch {} };
  }, [editor]);

  return null;
};


